// import external modules
import React from "react";
import { NavLink } from "react-router-dom";

// Styling
import "../../../../assets/scss/components/sidebar/sidemenu/sidemenu.scss";

import SideMenu from "../sidemenuHelper";
import { connect } from "react-redux";
import { getUnreadInquiriesCount } from "../../../../redux/actions/apiAction/inquiries/inquiries";
import { getSelectedSideMenu } from "../../../../redux/actions/apiAction/sideMenuDropdown/sideMenuDropdownActions";
import { SideBarNavigation } from "../../../../navigation/SideBarNavigation";
import { ChevronRight } from "react-feather";

// Loader Image

class SideMenuContent extends React.Component {
  getUnreadCountApiCall = async () => {
    await this.props.getUnreadInquiriesCount({});
  };

  componentDidMount() {
    const currentPath = window.location.pathname;
    let found = false;

    for (const menu of SideBarNavigation) {
      if (menu.subMenu && menu.subMenu.length) {
        for (const subMenu of menu.subMenu) {
          if (subMenu.path === currentPath) {
            this.props.getSelectedSideMenu(menu.id, subMenu.id);
            found = true;
            break;
          }
        }
        if (found) break;
      } else if (menu.path === currentPath) {
        this.props.getSelectedSideMenu(menu.id, null);
        break;
      }
    }
  }

  toggleMultipleMenu = (menuId, subMenuId) => {
    if (typeof subMenuId !== "undefined") {
      // Submenu click: set both
      this.props.getSelectedSideMenu(menuId, subMenuId);
    } else {
      // Parent menu click: open/close
      if (this.props.selectedSideMenuState.sideMenuIndex === menuId) {
        this.props.getSelectedSideMenu(null, null);
      } else {
        this.props.getSelectedSideMenu(menuId, null);
      }
    }
  };

  render() {
    if (!this.props.unreadInquiriesCount.is_set_up_once) {
      this.getUnreadCountApiCall();
    }
    // all permission Array
    const permissionsArray = this.props.permissions;
    //filter permissions side menu
    const filteredPermittedMenu = this.props.isSuperAdmin
      ? SideBarNavigation
      : SideBarNavigation.map((sideMenu) => {
          if (sideMenu.subMenu && sideMenu.subMenu.length > 0) {
            const subMenu = sideMenu.subMenu
              .map((subMenu) => {
                const getPermissionStatus = permissionsArray.find(
                  (permission) =>
                    permission.path === subMenu.path &&
                    permission.isAccess === true
                );
                if (!getPermissionStatus) return null;
                return { ...subMenu };
              })
              .filter((item) => item !== null);
            if (!subMenu.length) {
              return null;
            }
            return { ...sideMenu, subMenu };
          } else {
            const getPermissionStatus = permissionsArray.find(
              (permission) =>
                permission.path === sideMenu.path &&
                permission.isAccess === true
            );
            if (!getPermissionStatus) {
              return null;
            }
            return {
              ...sideMenu,
            };
          }
        }).filter((item) => item !== null);

    return (
      <SideMenu
        className="sidebar-content"
        toggleSidebarMenu={this.props.toggleSidebarMenu}
      >
        {filteredPermittedMenu.length
          ? filteredPermittedMenu.map((item, index) => {
              if (item.subMenu && item.subMenu.length) {
                return (
                  <SideMenu.MenuMultiItems
                    key={item.path}
                    className="position-relative"
                    Icon={item.icon}
                    name={item.title}
                    ArrowRight={<ChevronRight />}
                    selected={
                      this.props.selectedSideMenuState.sideMenuIndex === item.id
                        ? true
                        : false
                    }
                    collapsedSidebar={false}
                    toggle={() => {
                      this.toggleMultipleMenu(item.id);
                    }}
                  >
                    {item.subMenu.map((subMenu) => (
                      <div
                        className={`multiple_side_menu ${
                          this.props.selectedSideMenuState.subMenuIndex ===
                          subMenu.id
                            ? "active"
                            : ""
                        }`}
                        key={subMenu.path}
                        onClick={() => {
                          this.toggleMultipleMenu(item.id, subMenu.id);
                        }}
                      >
                        <NavLink
                          to={subMenu.path}
                          activeClassName="active"
                          className=" text-white active"
                        >
                          <i className="menu-icon">{subMenu.icon}</i>
                          <span
                            style={{ fontWeight: "bold" }}
                            className="menu-item-text"
                          >
                            {subMenu.title}{" "}
                            {subMenu.title === "Inquiries" && (
                              <span>
                                ({this.props.unreadInquiriesCount.total})
                              </span>
                            )}
                          </span>
                        </NavLink>
                      </div>
                    ))}
                  </SideMenu.MenuMultiItems>
                );
              }
              return (
                <SideMenu.MenuSingleItem
                  key={item.path}
                  index={index}
                  onClick={() => {
                    this.props.getSelectedSideMenu(item.id, null);
                  }}
                >
                  <NavLink to={item.path} activeClassName="active">
                    <i className="menu-icon">{item.icon}</i>
                    <span
                      style={{ fontWeight: "bold" }}
                      className="menu-item-text"
                    >
                      {item.title}{" "}
                      {item.title === "Inquiries" && (
                        <span>({this.props.unreadInquiriesCount.total})</span>
                      )}
                    </span>
                  </NavLink>
                </SideMenu.MenuSingleItem>
              );
            })
          : new Array(20).fill().map((item, index) => {
              return <div key={index}></div>;
            })}
      </SideMenu>
    );
  }
}

// export default SideMenuContent;

const mapStateToProps = ({
  inquiries,
  login,
  userPermissions,
  selectedSideMenu,
}) => {
  const { unreadInquiriesCount } = inquiries;
  const loginUser = login.loginUser;
  const permissions = userPermissions.userPermissions;
  const isSuperAdmin = userPermissions.isSuperAdmin;
  const selectedSideMenuState = selectedSideMenu.selectedSideMenu;
  return {
    unreadInquiriesCount,
    loginUser,
    permissions,
    isSuperAdmin,
    selectedSideMenuState,
  };
};

const mapDispatchToProps = {
  getUnreadInquiriesCount,
  getSelectedSideMenu,
};

export default connect(mapStateToProps, mapDispatchToProps)(SideMenuContent);
